import React from 'react';
import PageError from '..';

type ErrorBoundaryProps = {
  children: any;
  onError?: () => void;
  type?: number;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(_: Error) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    this.props.onError && this.props.onError();
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.type === 500 ? <PageError type={500} /> : null;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
